import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Benefits: React.FC = () => {
  const benefits = [
    {
      title: 'Custom Revenue Pipelines',
      description: 'We build your end-to-end flow from lead intake to quote, close, invoice, and repeat purchase.'
    },
    {
      title: 'Lead Funnel Systems',
      description: 'Capture, qualify, and nurture leads automatically so fewer prospects slip through the cracks.'
    },
    {
      title: 'Sales Automation',
      description: 'Automated follow-up at every stage keeps opportunities moving without manual chasing.'
    },
    {
      title: 'Custom Integrations',
      description: 'Connect forms, CRM, email, SMS, and scheduling tools into one revenue-focused operating system.'
    }
  ];

  return (
    <section className="benefits-section-modern">
      <Container>
        <Row>
          <Col lg={10} className="mx-auto">
            <div className="benefits-grid">
              {benefits.map((benefit, index) => (
                <div key={index} className="benefit-item-modern">
                  <h4 className="benefit-title-modern">{benefit.title}</h4>
                  <p className="benefit-description-modern">{benefit.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Benefits;
